import sunny from '@/assets/team/board-sunny-zhang.png'
import james from '@/assets/team/board-james-owusu.jpg'
import emmaline from '@/assets/team/board-emmaline-datey.png'
import omai from '@/assets/team/board-omai-kofi.png'
import bisi from '@/assets/team/board-bisi-akintanyo.png'
import robert from '@/assets/team/board-robert-owusu-ansah.png'
import danie from '@/assets/team/board-danie-botha.png'
import type { Advisor } from '@/types/team'

export const board: Advisor[] = [
  { name: 'Dr. Sunny Shuoyang Zhang', role: 'Advisory Board', image: sunny },
  { name: 'Dr. James Owusu', role: 'Advisory Board', image: james },
  { name: 'Emmaline Datey', role: 'CEO, ICS Africa Ltd', image: emmaline },
  { name: 'Dr. Omai Kofi', role: 'Advisory Board', image: omai },
  { name: 'Madam Bisi Akintanyo', role: 'CEO of GText Suites', image: bisi },
  { name: 'Mr. Robert Owusu Ansah', role: 'Executive Chairman & CEO, PRAK Group', image: robert },
  { name: 'Mr. Danie Botha', role: 'Advisory Board', image: danie },
]
